import React, { Fragment } from "react";

const CoreValues = () => {
  return (
    <Fragment>
      <section className="bg-gray-50 bg-opacity-85">
        <div className="container px-8 py-8 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-12">
          <div className="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
            <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-normal text-green-900 sm:text-5xl md:mx-auto custom-font-2">
              <span className="relative inline-block">
                <span className="relative">Our </span>
              </span>{" "}
              Core Values
            </h2>
            <p className="text-gray-700 text-xl tracking-wide font-medium custom-font-2">
              At Solarich, our foundation is built upon a set of unwavering core
              values that define our identity and culture, driving us with a
              deep commitment to excellence in all we do.
            </p>
          </div>
          <div className="grid gap-5 mb-8 md:grid-cols-2 lg:grid-cols-3">
            <div className="p-5 duration-300 transform bg-white border rounded-xl shadow-md hover:-translate-y-2 custom-font-2">
              <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="main-grid-item-icon text-amber-500"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h6 className="mb-2 text-xl font-semibold leading-5">
                Customer Satisfaction
              </h6>
              <p className="text-lg font-medium tracking-wide text-gray-900">
                We are committed to ensuring that our customers are satisfied
                with our products and services.
              </p>
            </div>
            <div className="p-5 duration-300 transform bg-white border rounded-xl shadow-md hover:-translate-y-2 custom-font-2">
              <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="main-grid-item-icon text-amber-500"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h6 className="mb-2 text-xl font-semibold leading-5">
                Integrity
              </h6>
              <p className="text-lg font-medium tracking-wide text-gray-900">
                We operate with honesty, transparency, and ethical business
                practices.
              </p>
            </div>
            <div className="p-5 duration-300 transform bg-white border rounded-xl shadow-md hover:-translate-y-2 custom-font-2">
              <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="main-grid-item-icon text-amber-500"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h6 className="mb-2 text-xl font-semibold leading-5">
                Innovation
              </h6>
              <p className="text-lg font-medium tracking-wide text-gray-900">
                We embrace creativity, continuously explore new opportunities,
                and strive for excellence in our work.
              </p>
            </div>
            <div className="p-5 duration-300 transform bg-white border rounded-xl shadow-md hover:-translate-y-2 custom-font-2">
              <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="main-grid-item-icon text-amber-500"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h6 className="mb-2 text-xl font-semibold leading-5">
                Sustainability
              </h6>
              <p className="text-lg font-medium tracking-wide text-gray-900">
                We promote sustainable practices and products to ensure the
                preservation of our environment.
              </p>
            </div>
            <div className="p-5 duration-300 transform bg-white border rounded-xl shadow-md hover:-translate-y-2 custom-font-2">
              <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="main-grid-item-icon text-amber-500"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h6 className="mb-2 text-xl font-semibold leading-5">
                Accountability
              </h6>
              <p className="text-lg font-medium tracking-wide text-gray-900">
                We take responsibility for our actions, decisions and outcomes,
                and continuously learn from our mistakes.
              </p>
            </div>
            <div className="p-5 duration-300 transform bg-white border rounded-xl shadow-md hover:-translate-y-2 custom-font-2">
              <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="main-grid-item-icon text-amber-500"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h6 className="mb-2 text-xl font-semibold leading-5">Teamwork</h6>
              <p className="text-lg font-medium tracking-wide text-gray-900">
                We foster a collaborative working environment, where every
                member of the team is respected and valued.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default CoreValues;
